import { LogoMark } from '@/components/LogoMark/LogoMark';

import styles from './LoadingScreen.module.css';

export interface LoadingScreenProps {
  message: string;
}

/** A full-window hold while something the whole app waits on is in flight. */
export function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div className={styles.screen}>
      <span className={styles.mark}>
        <LogoMark size={44} />
      </span>
      <p className={styles.message} role="status">
        {message}
      </p>
    </div>
  );
}
